<template>
    <div>
        <md-dialog
            :md-active.sync="show"
            class="mkt-ops -main-font bookprice-dialog-delete-file"
            :md-click-outside-to-close="false"
            >
            <md-dialog-title style="padding-left: 35px;"
                             >Manage file template</md-dialog-title
            >

            <div class="dialog-content">
                <div class="md-layout">

                    <!-- TABLE -->
                    <div class="md-layout-item md-size-100 table-import-file">
                        <!-- HEAD -->
                        <div class="divHeadList">
                            <div style="width: 5%;">
                                <label class="-mkt-checkbox-container">
                                    <input type="checkbox"
                                           v-model="checkedFileAll"
                                           @click="selectedCheckedAllFile()"/>
                                   <span class="-mkt-checkbox"></span>
                                </label>
                            </div>
                            <div style="width: 55%;" class="-font-kanit">File Name</div>
                            <div style="width: 20%;text-align:center" class="-font-kanit">Create date</div>
                            <div style="width: 20%;text-align:center" class="-font-kanit">Modify date</div>
                        </div>

                        <!-- BODY -->
                        <div class="divBodyList">
                            <div
                                v-show="tableFilesList.length === 0"
                                :class="'row-bg-gray'"
                                style="display: block; text-align: center; font-size: 14px;"
                                >
                                No data in table.
                            </div>

                            <div :class="'row-bg-gray -file'"
                                v-for="(file, fileIndex) in tableFilesList"
                                :key="fileIndex">
                                <div style="width: 5%;">
                                    <label class="-mkt-checkbox-container">
                                        <input type="checkbox"
                                               v-model="checkedFile"
                                               :value="file.id"
                                               @click="selectedCheckedFile(file.id)"/>
                                        <span class="-mkt-checkbox"></span>
                                    </label>
                                </div>
                                <div style="width: 55%;">
                                    {{ file.name }}
                                </div>
                                <div style="width: 20%;text-align:center">
                                    {{ formatDate(file.createdTime) }}
                                </div>
                                <div style="width: 20%;text-align:center">
                                    {{ formatDate(file.modifiedTime) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <md-dialog-actions style="padding: 10px 30px 15px 17px;">
                <div class="md-layout-item md-size-20"></div>
                <div
                    class="md-layout-item md-size-60"
                    style="text-align: center; font-style: italic;"
                    >
                    number of lines in page ({{ tableFilesList.length }})
                </div>
                <div class="md-layout-item md-size-20" style="text-align: right;">
                    <md-button class="-cancel" @click="onClickCancel()" style="text-align: center">
                        CANCEL
                    </md-button>
                    <md-button class="-confirm" @click="onClickConfirm()"
                        style="text-align: center">
                        DELETE
                        </md-button>
                </div>
            </md-dialog-actions>
        </md-dialog>

        <dialog-confirm
            :show="showDialogConfirm"
            :title="titleDialog"
            :content="contentDialog"
            :confirmText="confirmText"
            :cancelText="cancelText"
            @cancel="onCancel()"
            @confirm="onConfirm()"
            ></dialog-confirm>

        <md-snackbar
            :md-position="position"
            :md-duration="isInfinity ? Infinity : duration"
            :md-active.sync="showSnackbar"
            md-persistent
            >
            <span>{{ contentSnackbar }}</span>
            <md-button class="md-primary" @click="showSnackbar = false">OK</md-button>
        </md-snackbar>
    </div>
</template>

<script>
import DialogConfirm from "./../../shared/dialog-confirm";
import BookpriceService from "@/services/bookprice";
import moment from "moment-timezone";

export default {
    name: "dialog-files-list",
    components: {
        DialogConfirm
    },
    props: {
        show: {
            type: Boolean,
            required: true
        },
        data: {
            type: Array,
            required: true
        }
    },
    watch: {
        show() {
            if(this.show) {
                this.tableFilesList = this.data;
            }
        }
    },
    data() {
        return {
            checkedFileAll: false,
            checkedFile: [],
            checkEvent: "",
            showDialogConfirm: false,
            titleDialog: "",
            contentDialog: "",
            confirmText: "OK",
            cancelText: "CANCEL",
            tableFilesList: [],
            fileID: "",
            fileIdDelete: "",
            fileNameDelete: "",
            showSnackbar: false,
            position: "center",
            duration: 20000,
            isInfinity: false,
            contentSnackbar: ""
        };
    },
    methods: {
        formatDate(date) {
            return moment(date).format("DD-MM-YYYY HH:mm:ss");
        },
        selectedCheckedAllFile() {
            this.checkedFile = [];
            if (!this.checkedFileAll) {
                for (let file in this.tableFilesList) {
                    this.checkedFile.push(this.tableFilesList[file].id);
                }
            }
        },
        selectedCheckedFile(code) {
            console.info('code', code);
            if(this.checkedFile.indexOf(code) == - 1) {
                this.checkedFile.push(code);
            } else {
                this.checkedFile.splice(this.checkedFile.indexOf(code), 1);
            }

            if(this.checkedFile.length !== this.tableFilesList.length) {
                this.checkedFileAll = false;
            } else {
                this.checkedFileAll = true;
            }
        },
        fileDelete() {
            this.checkBackdrop = false;
            this.loading = true;
            BookpriceService.deleteFilePriceList(this.fileIdDelete).then(response => {
                this.loading = false;
                if(!response.status) {
                    this.contentSnackbar = "Delete file unsuccessfully. " + response.msg;
                    this.showSnackbar = true;
                } else {
                    let index = this.tableFilesList.map(function(e) {
                        return e.id;
                    }).indexOf(this.fileIdDelete);
                    
                    if(index > - 1) {
                        this.tableFilesList.splice(index, 1);
                    }

                    this.contentSnackbar = "Delete file '" 
                        + this.fileNameDelete + "' successfully.";
                    this.showSnackbar = true;
                }
            });
        },
        onClickCancel() {
            this.checkEvent = "cancel";
            this.titleDialog = "";
            this.cancelText = "CANCEL";
            this.confirmText = "YES";
            this.contentDialog = "Are you sure you want to close ?";
            this.showDialogConfirm = true;
        },
        onClickConfirm() {
            console.log('>>>');
//            if(this.fileID == "") {
            console.info('this.checkedFile', this.checkedFile);
            if(this.checkedFile.length < 1) {
                this.contentSnackbar = "Please select file.";
                this.showSnackbar = true;
                return false;
            }

            this.checkEvent = "confirm";
            this.titleDialog = "Delete File(s)";
            this.cancelText = "NO";
            this.confirmText = "YES";
            this.contentDialog = "Are you sure you want to delete "+this.checkedFile.length+" files?";
            this.showDialogConfirm = true;
        },
        onCancel() {
            this.showDialogConfirm = false;
        },
        onConfirm() {
            if(this.checkEvent === "cancel") {
                this.$emit("cancel");
            } else if(this.checkEvent === "confirm") {
                this.$emit("confirm", this.checkedFile);
            }
            this.checkedFileAll = false;
            this.checkedFile = [];
            this.showDialogConfirm = false;
        }
    }
};
</script>

<style lang="scss">
.bookprice-dialog-delete-file {
  width: 85%;
  height: 60%;
  transform: unset !important;
  top: 20% !important;
  left: 11% !important;
  font-weight: 400 !important;

  .table-import-file {
    padding: 0;

    .divBodyList {
      height: calc(85vmin - 183px);

      .row-bg-gray:hover {
        &.-file {
          cursor: pointer;
        }
      }

      .row-bg-blue {
        border-radius: 4px;
        background: #e8f0fe;
        color: #005fd0;

        .-delete {
          color: #005fd0 !important;
        }
      }
    }
  }
}
</style>